<template>
  <div
    class="logo cursor-pointer"
    @click="redirectToHome"
  />
</template>

<script>
import { R_START } from '@/router/routes';

export default {
  name: 'Logo',
  methods: {
    redirectToHome() {
      this.$router.push({
        name: R_START,
      });
    },
  },
};
</script>
